import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { CancelBtnComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-update-field",
	imports: [COMMON_IMPORTS, LangValPipe, GenInputComponent, CancelBtnComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="row">
			<div class="col-6 col-md-4 ">
				<label>{{ fieldName | langVal }}</label>
				<app-gen-input
					type="textarea"
					[actualObj]="this"
					[title_ph_lang]="fieldName"
					fieldName="value"
				>
				</app-gen-input>
			</div>
		</div>
		<div class="modal-btns">
			<app-cancel-btn (click)="onClose.emit()" />
			<button
				class="btn btn-primary"
				tabindex="5"
				(click)="onClose.emit(value)"
			>
				{{ "update" | langVal }}
			</button>
		</div>
	`,
})
export class UpdateFieldComponent extends Modalable {
	value: string = ""
	@Input() fieldName: string = ""
}
